var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"buttons","className":"ui grey three item inverted bottom fixed menu transition hidden"}}),(_vm.data)?_c('iframe',{staticClass:"w-100",attrs:{"src":_vm.data,"id":"viewer","height":_vm.height,"scrolling":"no"},on:{"load":_vm.load}}):_c('p',[_vm._v("Loading PDF...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }